<template>
  <div class="cart display-single-price" :class="{ 'display-single-price--minisite': isMinisite }">
    <client-only>
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    </client-only>
    <client-only v-if="$store.getters['UI/debug']">
      <div class="debug__header">DEBUG basket.id {{ basketId }}</div>
      <div v-if="abandonedBasket" class="debug__header">DEBUG ABANDONED BASKET {{ abandonedBasket }}</div>
      <div v-if="minisite" class="debug__header">DEBUG MINISITE {{ minisite }}</div>
    </client-only>
    <div v-if="$fetchState.pending"></div>
    <div v-if="!$fetchState.pending && basketId && basketItems && basketItems.length >= 1">
      <h1 v-if="!isMinisite">Your Basket</h1>
      <form id="cart-form" action="" method="post">
        <div class="form-section-container">
          <table id="shopping-cart-table" class="cart-table data-table">
            <thead>
              <tr class="first last">
                <th><span class="nobr">Item</span></th>
                <th rowspan="1"><span class="nobr">Details</span></th>
                <th>Payment</th>
                <th class="a-center cart-price-head" colspan="1">
                  <span class="nobr">Cost</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <CheckoutCartProduct v-for="item in basketItems" :id="item.id" :key="`${item.id}`" class="first odd" />
            </tbody>
          </table>
        </div>

        <CheckoutCartVoucherCampaign v-if="!isMinisite" />

        <div v-if="!isMinisite && basketItemsCrossSell && basketItemsCrossSell.length > 0" class="checkout-cart__crosssell">
          <div class="checkout-cart__crosssell">
            <p class="checkout-cart__crosssell-heading">You might also like...</p>
          </div>

          <div class="checkout-cart__crosssell-grid">
            <CheckoutCartCrossSellProduct
              v-for="(item, index) in basketItemsCrossSell"
              :key="`${item.sku}-${index}`"
              :item="item"
              class="product__crosssell-item items-list__item"
            />
          </div>
        </div>

        <div class="cart-totals-wrapper">
          <div class="cart-totals">
            <table id="shopping-cart-totals-table">
              <colgroup>
                <col />
                <col width="1" />
              </colgroup>
              <tfoot>
                <tr>
                  <td class="a-right savings" colspan="2">
                    <div v-if="basket?.save" class="savings__circle">
                      <div class="savings__circle--label">
                        YOU SAVE
                      </div>
                      <div class="savings__circle--save">{{ formatCurrency(basket.save) }}</div>
                    </div>
                    <div v-if="basket?.totals?.total" class="savings__totals">
                      <div v-if="basket?.totals?.discount_code && basket?.totals?.discount">
                        <strong class="discount-label">Discount ({{ basket.totals.discount_code }})</strong>
                        <strong class="a-right grand-total-price">-{{ formatCurrency(basket.totals.discount) }}</strong>
                      </div>
                      <div>
                        <strong class="grand-total-label">Total</strong>
                        <strong class="a-right grand-total-price">{{ formatCurrency(basket.totals.total) }}</strong>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div class="cart-footer-wrap">
          <button v-if="!isMinisite" type="submit" title="Continue Shopping" class="btn-continue back-btn mdl-button" @click.prevent="handleContinueShopping()">
            <font-awesome-icon :icon="['fal', 'chevron-left']" class="fa fa-stack-3x leftArrow" />
            <span>Continue Shopping</span>
          </button>
          <button type="submit" class="btn-checkout mdl-button" title="Go to checkout" @click.prevent="handleGoToCheckout()">
            <span>Go to checkout<font-awesome-icon :icon="['fal', 'chevron-right']" class="fa fa-stack-3x rightArrow"/></span>
          </button>
        </div>
      </form>
    </div>

    <client-only v-if="!$fetchState.pending && basketId && basketItems && basketItems.length >= 1">
      <WaysToPay />
    </client-only>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { formatCurrency } from '~/lib/util/basket'
import { getGA4EcommerceNullPayload, getGA4ViewCartPayload } from '~/lib/util/gtmGA4'
import { getStatusCodeFromPath, callAWSFrontendExtrasAPI } from '~/lib/util/aws'
import { createPathOrURLWithQueryParam } from '~/lib/util/page'
import consentStatusCheckoutCart from '@/mixins/consentStatusCheckoutCart'

export default {
  components: {
    CheckoutCartProduct: () => import('~/components/common/checkout/CheckoutCartProduct.vue'),
    CheckoutCartCrossSellProduct: () => import('~/components/common/checkout/CheckoutCartCrossSellProduct.vue'),
    CheckoutCartVoucherCampaign: () => import('~/components/common/checkout/CheckoutCartVoucherCampaign'),
    WaysToPay: () => import('~/components/common/WaysToPay.vue')
  },
  fetchOnServer: false,
  mixins: [consentStatusCheckoutCart],
  async fetch() {
    // this.isLoading = true
    const status = getStatusCodeFromPath({ context: this })
    if (status !== 200) {
      if (process.server) {
        this.$nuxt.context.res.statusCode = status
      }
      this.$store.commit('UI/statusCode', status, { root: true })
      return
    }

    // Look for an available Query String and retrieve the URL path
    const path = this.$route.path
    const query = this.$nuxt.context.query
    const useCache = this.$store.getters['UI/useCache']
    console.log('page=CHECKOUT_CART')
    console.log('path=', path)
    console.log('query=', query)
    console.log('QS useCache=', useCache)

    const id = this.$store.getters['cart/CartId']
    console.log(`Basket id=${id}`)

    if (!id) {
      console.error('No Basket ID found, redirecting to empty cart')
      this.redirectToCheckoutCartEmpty()
      this.isLoading = false
      return
    }

    await callAWSFrontendExtrasAPI({ context: this, useCache })
    this.isLoading = false
  },
  layout(context) {
    return (context?.params?.minisite && '1ColumnMinisite') || 'default'
  },
  data() {
    return {
      isLoading: false,
      abandonedBasket: undefined,
      isMinisite: false
    }
  },
  computed: {
    ...mapGetters({
      basket: 'basket/payload',
      basketId: 'basket/id',
      basketItems: 'basket/items',
      basketItemsCrossSell: 'basket/items_cross_sell',
      minisite: 'cart/minisite'
    })
  },
  mounted() {
    console.warn(`mixins/checkoutCart MOUNTED`)
    // Call parent's mountedInit first (if it exists)
    if (typeof consentStatusCheckoutCart.mountedInit === 'function') {
      consentStatusCheckoutCart.mountedInit.call(this)
    }
    this.checkMinisite()
  },

  created() {
    this.$nuxt.$on('GIFT_OPTION_CHANGE', ({ id, checked, flag }) => {
      console.info(`GIFT_OPTION_CHANGE id=${id} checked=${checked} flag=${flag}`)
      const i = { ...this.$store.getters['basket/item'](id) }
      // let options = {}
      // if (!i?.options || i.options === null) {
      //   options = {
      //     allow_as_gift: false,
      //     allow_as_xmas_gift: false
      //   }
      //   console.info('NEW DEFAULT options=', options)
      // } else {
      //   options = { ...i?.options }
      //   console.info('CLONE options=', options)
      // }

      const options = {
        allow_as_gift: false,
        allow_as_xmas_gift: false
      }

      // UPDATE the option flag
      options[flag] = checked

      console.info('FINAL options=', options)

      i.options = {}
      i.options = { ...options }
      i.use_default_address = !(i.options.allow_as_gift || i.options.allow_as_xmas_gift)
      i.delivery_address = null

      this.$store.commit('basket/item', i)

      console.info('FINAL i=', i)
      console.info(`GIFT_OPTION_CHANGE id=${id} use_default_address=${i.use_default_address}`)
    })

    this.$nuxt.$on('BASKET_READY', ({ ready, basket }) => {
      console.error(`Event BASKET_READY for checkout/cart ready=${ready} basket=`, basket)
      if (!basket) {
        return
      }

      if (basket.items.length === 0) {
        this.redirectToCheckoutCartEmpty()
      }

      this.basket && this.$nuxt.$emit('BASKET_READY_CONSENT_STATUS', { success: true, basket: this.basket, cartPhase: 'CHECKOUT_CART' })
      this.basket && this.$nuxt.$emit('DOT_DIGITAL_TRACKING_CART_INSIGHT', { success: true, basket: this.basket, cartPhase: 'CHECKOUT_CART' })
    })
    this.$nuxt.$on('TOGGLE_LOADING', value => {
      this.isLoading = value
    })

    this.isLoading = true
  },

  // beforeDestroy() {
  //   window && window.removeEventListener('consent_status', this._onConsentStatus)
  //   this.$nuxt && this.$nuxt.$off('BASKET_READY', this._onBasketReadyConsentStatus)
  //   this.$nuxt && this.$nuxt.$off('BASKET_READY_CONSENT_STATUS', this._onBasketReady)
  // },

  methods: {
    triggerViewCart() {
      console.error('Triggering view_cart')
      // GA4 Fire view_cart event
      this.$config.GA4Syntax && this.$config.GA4FireEcommerceNull && this.$gtm && this.$gtm.push(getGA4EcommerceNullPayload())
      this.$config.GA4Syntax && this.$gtm && this.$gtm.push(getGA4ViewCartPayload({ basket: this.basket }))
    },
    checkMinisite() {
      console.log('checkMinisite PARAMS=', this.$route?.params)
      console.log('checkMinisite this.minisite=', this.minisite)
      if (this?.basketItems.length > 1 && this.$route?.params?.minisite) {
        console.error(`MINISITE - Too many prods #${this?.basketItems.length} in the Basket`)
        this.$store.commit('cart/minisite', undefined)

        if (this.$route?.params?.id && this.$route?.params?.shortsitecode) {
          const redirect = `/checkout/cart/${this.$route?.params?.id}/${this.$route?.params?.shortsitecode}`
          console.log('MINISITE - REDIRECT to ', redirect)
          window.location.href = createPathOrURLWithQueryParam({ pathOrURL: redirect, query: this.$route.query })
        }
        return false
      }

      if (!this.$route?.params?.minisite) {
        console.error('NOT A MINISITE BASKET')
        this.$store.commit('cart/minisite', undefined)
        return false
      }

      if (this.$route?.params?.minisite && !this?.minisite) {
        console.error('NOT FOUND ANY MINISITE DATA')
        const redirect = `/checkout/cart/${this.$route?.params?.id}/${this.$route?.params?.shortsitecode}`
        console.log('MINISITE - REDIRECT to ', redirect)
        window.location.href = createPathOrURLWithQueryParam({ pathOrURL: redirect, query: this.$route.query })
        return false
      }

      this.isMinisite = true

      const shortsiteCode = this?.basketItems[0]?.shortsite_code || undefined
      const paramsShortsiteCode = this.$route?.params?.shortsitecode || undefined
      console.log('MINISITE - Found Basket shorsite_code=', shortsiteCode)
      console.log('MINISITE - Found From URL params shorsite_code=', paramsShortsiteCode)
      return shortsiteCode !== paramsShortsiteCode
    },
    redirectToCheckoutCartEmpty() {
      console.log(`redirectToCheckoutCartEmpty -> ${this.$config.baseURL}/checkout/cart/empty`)
      window.location.href = createPathOrURLWithQueryParam({ pathOrURL: `${this.$config.baseURL}/checkout/cart/empty`, query: this.$route.query })
      return true
    },

    formatCurrency(value) {
      return formatCurrency(value)
    },
    handleContinueShopping() {
      window.location.href = createPathOrURLWithQueryParam({ pathOrURL: `/`, query: this.$route.query })
      return true
    },
    async handleGoToCheckout() {
      this.isLoading = true

      // Clear andy Funnel messages
      this.$store.commit('cart/GenericMessage', undefined)
      this.$store.commit('cart/PersistentMessage', undefined)

      const items = this.basketItems.map(i => ({
        id: i.id,
        delivery_address: i?.delivery_address || null,
        use_default_address: i?.use_default_address,
        options: i?.options || {}
      }))

      const selectedVoucherCamaping = this.$store.getters['cart/VoucherCamapigns'].find(c => c?.selected === true)
      console.log('handleGoToCheckout selectedVoucherCamaping=', selectedVoucherCamaping)

      const data = JSON.stringify({
        items,
        minisite: this.isMinisite ? this?.minisite : null,
        voucher_campaign: selectedVoucherCamaping || null
      })

      const url = `${this.$config.AWSAPIGatewayURL}/basket/id/${this.basketId}/update-funnel-info`

      console.info(`handleGoToCheckout data=`, data)
      console.info(`handleGoToCheckout url=${url}`)
      const config = {
        method: 'put',
        maxBodyLength: Infinity,
        url,
        headers: {
          'x-api-key': this.$config.AWSAPIGatewayXAPIKEY,
          'Cache-Control': 'max-age=0',
          'Content-Type': 'application/json'
        },
        data
      }

      const ret = await this.$axios
        .request(config)
        .then(response => {
          console.info('handleGoToCheckout payload=', response.data.payload)

          // UPDATE The Basket on the Storage
          this.$store.commit('basket/payload', response.data.payload)

          return response.data.payload
        })
        .catch(error => {
          console.error('handleGoToCheckout', error)
          // TODO SHOW ERROR MESSAGE
          return false
        })

      if (ret?.id) {
        // redirect to the first ENV specific page
        let redirectURL = `/mcheckout/billing`
        if (this.$config.FunnelURI) {
          redirectURL = this.$config.FunnelURI

          const isStage = window.location.host.split(':')[0] === 'stage.magazine.co.uk'
          console.log('Domain=', window.location.host.split(':')[0])
          if (isStage) {
            redirectURL = this.$config.FunnelURIStage
          }
        }
        console.info(`handleGoToCheckout redirecting to ${redirectURL}`)
        window.location.href = createPathOrURLWithQueryParam({ pathOrURL: redirectURL, query: this.$route.query })
      }
      this.isLoading = false
      return ret
    }
  },

  // To check more options, link https://github.com/nuxt/vue-meta#script-object
  // To check how it is working https://nuxtjs.org/faq/duplicated-meta-tags/
  head() {
    return {
      title: 'Shopping Cart',
      meta: [
        {
          name: 'keywords',
          content: 'Magazine.co.uk'
        },
        {
          name: 'robots',
          content: 'NOINDEX,NOFOLLOW'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
/* ==========================================================================
        MAGAZINE.CO.UK VARIABLES
       ========================================================================== */

$prodcutOfferColor: #b30d00;
$buttonAddToCartColor: #00933e;
/**** Magazine Colours ****/
/* Site Background */
$bgSiteColor: #fff;
/* Text Colours */
$bodyTextColor: #333;
$headingColor: #ff0d00;
$mobileBodyTextColor: #333;
/* Navigation Colours */
$navBgColor: #fff;
$navBgColorMob: #333;
$navLinkColor: #000;
$navLinkColorNewsletter: #fff;
$navLinkHighlightColor: #ff0d00;
$navLinkHighlightColorBlack: #000;
$navTextColourMobile: #666;
/* Button Colours */
$buttonBgColor: $buttonAddToCartColor;
$buttonBgColorHv: #00b54c;
$buttonTextColor: #fff;
$mobileButtonBgColor: $buttonAddToCartColor;
$mobileButtonBgColorHv: #27ae60;
$buttonBgColorAction: $buttonAddToCartColor;
$buttonBgColorBack: #ff0d00;
$mobileButtonBgColorAction: $buttonAddToCartColor;
$mobileButtonBgColorBack: #ff0d00;
$buttonBgColorOutOfStock: #ff0d00;

/* Search */
$searchFontColor: #333;
$searchFontColorHv: #ff0d00;
$buttonSearchBgColorDesktop: #ff0d00;
$buttonSearchBgColorHvDesktop: #ff3d33;
$buttonSearchFontColorDesktop: #ffffff;

$buttonSearchBgColorMobile: #2dcc70;

$inputSearchBgColorDesktop: #ededed;
$inputSearchFontColorDesktop: #5c5c5c;
$inputSearchBorder: #a9a9a9;

/* Section Colours */
$sectionBackgroundHover: #e7e7e7;
$sectionBackground: #ededed;
$sectionBorder: #b0b0b0;
/* Form Colours */
$formLinkColor: #ff0d00;
$formErrorColor: #ff0d00;
$formValidColor: #00933e;
$formInputBorder: #ccc;
/* Footer Colours */
$footerLinkColor: #474747;
$footerLinkColorHover: #ff0d00;
$footerBGColourSocial: #333;
/* Mobile Only Colours */
$mobileIconColor: #dcdddc;
/* Heading Breaker */
$headingLineColor: #eee;
/* Category */
$categoryItemHoverBg: #ededed;
$categoryHeadingBg: #333;

/* Totals */
$totalsLabelColor: #333;
$totalsCurrencyColor: #ea4a68;
$totalsBorderColor: #a5a5a5;
/* Checkout */
$checkoutBgColor: #f5f5f5;
$checkoutBorderColor: #a5a5a5;
$checkoutLinkColor: #333;
$checkoutLinkColorActive: #ff0d00;

/* Notification */
$successNotificationBgColor: #41a940;
$successNotificationTextColor: #fff;
$successNotificationBorderColor: 2dcc70;

$errorNotificationBgColor: #ff0d00;
$errorNotificationTextColor: #fff;
$errorNotificationBorderColor: ff0d00;

/**** Magazine Typefaces ****/
$fontRegular: 'Open Sans', sans-serif;
$fontAlternate: 'Open Sans', sans-serif;
$fontRegularMobile: 'Open Sans', sans-serif;
$fontAlternateMobile: 'Open Sans', sans-serif;
/**** Transisitions ****/
$transitionSpeed: 0.25s;

// Large screen / wide desktop
//** Deprecated `$screen-lg` as of v3.0.1
$screen-lg: 1260px !default;
$screen-lg-min: $screen-lg !default;
//** Deprecated `$screen-lg-desktop` as of v3.0.1
$screen-lg-desktop: $screen-lg-min !default;

// So media queries don't overlap when required, provide a maximum
$screen-xs-max: ($screen-sm-min - 1) !default;
$screen-sm-max: ($screen-md-min - 1) !default;
$screen-md-max: ($screen-lg-min - 1) !default;

.rightArrow {
  float: right;
  margin: 4.5px;
}

.leftArrow {
  float: left;
  margin: 4.5px;
}

.mdl-button {
  padding: 9px !important;
}

@mixin clearfix {
  content: '';
  display: table;
  clear: both;
}

/* List Style */
/* Usage - Apply directly to <ul> or <ol> element */
@mixin list-style {
  list-style: none;
  padding: 0;
  margin: 0;
  @include clearfix;
}

h1 {
  margin: 0 0 15px;
  font-weight: 400;
  font-size: 2em !important;
}

.flex-center {
  display: flex;
  align-items: center;
}

@media (max-width: $screen-sm-min) {
  .product-cell-inner-wrap {
    display: block !important;
    content: unset !important;
    clear: unset !important;
  }

  .cart-footer-wrap {
    display: block !important;

    button.continue {
      float: left;
    }

    button.btn-checkout {
      float: right;
    }
  }

  .cart-totals-wrapper {
    margin: 20px 0;
  }

  .checkout-cart__crosssell {
    padding-top: 10px !important;
  }

  .checkout-cart__crosssell-grid {
    width: 90vw;

    .crossell-item {
      flex: 1 0 40%;
    }
  }

  .cart-table tr.even {
    height: 60px !important;
    margin: 0px 0px 20px 0 !important;

    .product-cart-remove,
    .product-cart-add {
      padding: 15px !important;
    }
  }

  .gift-options {
    margin: unset !important;
    padding-left: 10px !important;
    height: 44px !important;
    line-height: 44px !important;

    label {
      display: inline-flex;
      align-items: center;
      height: 44px;

      p {
        line-height: 44px !important;
      }

      input {
        margin: 0px 10px 0px 0px !important;
      }
    }
  }
}

/* ==========================================================================
        MAGAZINE CART STYLES
       ========================================================================== */
/**** Note - Magento cart styles vary massively in terms of style of markup and are not advisable to edit.
    /**** Generic Form Styles - Used across all steps of billing ****/

.checkout-cart {
  &__crosssell {
    max-width: 790px;
    background-color: #fff;
    clear: both;
    height: auto;
    padding-top: 20px;
    position: relative;
    text-align: center;
    transform: none;
    z-index: 100;
  }

  &__crosssell-heading {
    font-weight: 700;
    letter-spacing: 0.1em;
    margin: 0 0 10px;
    padding: 10px;
    font-size: 16px !important;
  }

  &__crosssell-grid {
    align-content: space-around;
    align-items: stretch;
    display: flex;
    // flex-flow: row nowrap;
    justify-content: center;
    max-width: 800px;
    overflow-x: scroll;
    padding-bottom: 5px;
  }
}

div.cart.display-single-price,
#cart-form,
.form-section-container,
.cart-totals-wrapper,
.cart-totals {
  width: 100% !important;
}

div.cart.display-single-price {
  padding-left: 15px;
  padding-right: 15px;
  max-width: 820px;
}

div.cart.display-single-price--minisite {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  width: 100% !important;
  max-width: unset !important;
}

#billing-form,
#multishipping-billing-form,
#delivery-form,
.cart {
  @include clearfix;

  /* Basic Form Element Styles */
  label {
    padding-top: 5px;
    font-size: 12px;

    em {
      color: $formErrorColor;
      margin-left: 5px;
    }
  }

  p {
    font-family: $fontAlternate;
    font-size: 12px;
  }

  input[type='text'],
  input[type='email'],
  select {
    padding: 5px;
    float: right;
  }

  select {
    max-width: 100%;
    font-size: 14px;
  }

  select option {
    font-size: 14px;
    line-height: 16px;
    font-family: $fontAlternate;
  }

  button {
    float: right;
    margin-left: 10px;
  }

  .name-firstname,
  .name-prefix {
    margin-bottom: 10px;
  }

  /* Default Magento Error Classes */
  input[type='text'].validation-passed,
  select.validation-passed {
    border: 1px solid $formValidColor;
  }

  input[type='text'].validation-failed,
  select.validation-failed {
    border: 1px solid $formErrorColor;
  }

  /* Form Structural Elements - Magento checkout steps feature many different layout types.
           Below styles should cater for different configurations of forms */
  li {
    @include clearfix;
    margin-bottom: 10px;

    .field {
      @include clearfix;
    }
  }

  .error {
    font-family: arial;
    color: #ff0d00;
    margin-top: 5px;
    width: 100%;
    float: none;
    text-align: left;
    padding: 0;
  }

  .checkbox-label-opt-out {
    font-size: 11px;

    a {
      font-size: 11px;
      text-decoration: none;
      color: black;
    }
  }
}

.back-link {
  margin-bottom: 20px;
  font-size: 12px;

  a {
    font-size: 12px !important;
  }
}

/**** Delivery Vouchers Styles ****/
.voucher-form-col {
  display: flex;
  flex-direction: column;
}

.deliver-voucher-image img {
  @include clearfix;
  max-width: 200px;
}

.grand-total-label {
  display: inline-block;
  margin-right: 7px;
  color: #333;
}

.discount-label {
  display: inline-block;
  text-transform: none;
  margin-right: 7px;
  color: #333;
}

#multishipping-payment-form {
  .error {
    font-family: arial;
    color: #ff0d00;
    margin-top: 5px;
    width: 100%;
    float: none;
    text-align: left;
    padding: 0;
  }
}

iframe#sagepaysuite-server-incheckout-iframe {
  border: none;
  width: 100%;
}

/**** Hiding header stuff in Checkout pages *****/
.mcheckout-billing-index,
.mcheckout-delivery-index,
.mcheckout-payment-index {
  #header-nav,
  .header-search,
  .nav-menu-btn {
    display: none !important;
  }

  .main-content,
  .sidebar {
    padding-top: 0;
  }
}

.order-confirmation-1click {
  .offer-payment-type {
    margin: 10px 0;
  }

  hr {
    border-top: 1px solid #ccc;
    margin: 10px 0 0px 0;
  }

  .form-section-title {
    h2 {
      font-weight: 600;
      color: red;
      font-size: 18px;
      margin-bottom: 0;
    }
  }

  background: white;
  border: 1px solid #a5a5a5;
  border-radius: 10px;
  //padding: 20px;
  margin: 20px 0;

  a {
    text-decoration: none;
  }

  button {
    @include button-style;
    width: 200px;
    font-size: 14px;

    &:disabled {
      background-color: #808080;
      color: #ffffff;
    }
  }

  .fa-chevron-right {
    line-height: 17px;
    float: right;
  }

  .form-section-title {
    h2 {
      font-weight: 600;
      padding-bottom: 0px;
      border-bottom: 0px solid #eee;
      font-size: 18px;
    }
  }

  .title--outer {
    margin: 20px 10px;
  }

  .offer-container {
    padding-bottom: 10px;
    margin: 20px;

    &--outer {
      background: #f4f4f4;
    }
  }

  .items-list {
    display: flex;
    overflow: auto;
    white-space: nowrap;
    background: #f4f4f4;

    //display: inline-flex;
    //flex-flow: row nowrap;
    //justify-content: center;
    //align-items: stretch;
    //align-content: space-between;
    &__item {
      background: white;
      white-space: initial;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      flex: 0 0 23%;
      min-width: 0;
      padding: 0.4375em;
      margin: 0.25em;

      &:hover {
        background-color: $sectionBackground;
        opacity: 0.7;
        filter: alpha(opacity=70);
      }

      &--checked,
      &--checked:hover {
        border: 0.0625em solid lightgreen;
        background: #e3fbe3;
        padding: 0.4375em;
        opacity: 1;
        filter: alpha(opacity=100);
      }

      border: 1px solid #cdcdcd;
      border-radius: 10px;
      cursor: pointer;
    }

    &__buttons {
      flex: 0 0 100%;
      justify-content: flex-end;
      align-items: center;
      margin: 10px;
      padding: 10px 50px;
      display: flex;
      flex-direction: column;

      &--btn {
        align-self: center;
      }

      &--comment {
        margin-top: 10px;
        font-size: 11px;
        color: #5f5f5f;
      }
    }

    &__error {
      flex: 0 0 70%;
      border: 1px solid #ff0d00;
      background: lightcoral;
      padding: 1em;
      color: black;
      text-align: center;
      display: none;
    }

    .product__information {
      padding: 0.5em 0.1em 0.1em 0.1em;

      .product__text {
        .product__magazine {
          min-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .product__offer {
          &--red {
            color: $headingColor;
          }
        }
      }
    }

    .product__image {
      position: relative;

      img {
        max-width: 100%;
        display: block;
        margin: 0 auto;
      }
    }

    .product__selection {
      position: relative;
      align-self: center;

      &--checkbox {
        display: flex;
        flex-direction: row;
        align-items: center;
        max-height: 25px;
        min-height: 25px;
      }

      input[type='checkbox'].css-checkbox {
        position: absolute;
        z-index: -1000;
        left: -1000px;
        overflow: hidden;
        clip: rect(0 0 0 0);
        height: 1px;
        width: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
      }

      input[type='checkbox'].css-checkbox + label.css-label {
        padding-left: 30px;
        height: 25px;
        display: inline-block;
        line-height: 25px;
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 25px;
        font-size: 12px;
        vertical-align: middle;
        cursor: pointer;
      }

      input[type='checkbox'].css-checkbox:checked + label.css-label {
        background-position: 0 -25px;
      }

      label.css-label {
        // background-image: url('../assets/img/csscheckbox.png');
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
    }
  }
}

/**** Cart Vouchers Styles ****/
.cart-vouchers-container {
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;

  .cart-voucher-type {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;

    img {
      max-height: 90px;
      max-width: 200px;
      padding: 10px;
    }

    &:hover {
      background: #ededed;
    }

    input[name='voucherTypeId'] {
      pointer-events: none;
      margin: 10px;
    }

    .info {
      text-wrap: normal;
    }
  }
}

.cart-totals-wrapper {
  .savings {
    position: relative;
    display: flex;
    justify-content: flex-end;
    flex-flow: row nowrap;

    &__totals {
      align-self: center;
      text-align: right;

      .nouppercase {
        text-transform: none;
      }
    }

    &__circle {
      align-self: center;
      margin-right: 20px;
      vertical-align: middle;
      background: white;
      border-radius: 100%;
      box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);
      color: #ff0d00;
      display: inline-block;
      height: 87px;
      text-align: center;
      width: 87px;

      border: 3px solid #ff0d00;
      height: 70px;
      width: 70px;

      &--label {
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        margin-top: 18px;
      }

      &--save {
        font-size: 16px;
        font-weight: 700;
        line-height: 1.3;
      }
    }
  }
}

.cart-vouchers-title {
  color: #000;
  font-weight: bold;
  padding-bottom: 5px;
  border-bottom: 1px solid #ccc;
}

.product-cell-payment-mobile {
  display: none;
}

.giftcard-options-msg {
  margin-top: 20px;
}

@media (max-width: $screen-xs-max) {
  .discount-label,
  .grand-total-label {
    text-transform: uppercase;
    color: #333;
    font-size: 13px;
  }

  .grand-total-price {
    color: #ff0d00;
    margin-right: 10px;
    font-size: 13px;
  }

  .order-confirmation-1click {
    //padding: 10px;
    .form-section-title {
      h2 {
        font-width: 600;
        color: red;
        font-size: 16px;
        margin-bottom: 0;
      }
    }

    button {
      @include button-style;
      font-size: 12px;
    }

    .items-list {
      align-content: center;

      &__item {
        flex: 0 0 40%;
      }

      &__buttons {
        padding: 5px;
      }
    }

    .product__image {
      max-width: 100%;
    }
  }

  .cart-vouchers-container {
    .cart-voucher-type {
      margin-top: 10px;

      img {
        max-height: 80px;
        max-width: 150px;
        padding: 5px 10px 5px 5px;
      }

      input {
        margin: 5px;
      }
    }
  }
}

/**** Form Section Container Styles ****/
.form-section-container {
  @include clearfix;
  margin-bottom: 20px;

  .success-msg {
    padding-bottom: 20px;
  }

  h3 {
    font-size: 14px;
    line-height: 15px;
    font-weight: bold;
    margin-bottom: 10px;
    text-transform: uppercase;
    color: $headingColor;
    font-family: $fontAlternate;
  }

  address {
    font-size: 14px;
    font-style: normal;
    color: $bodyTextColor;
  }

  a {
    text-decoration: underline;
    color: $formLinkColor;
    font-family: $fontAlternate;
    font-size: 14px;

    &:hover {
      text-decoration: none;
    }
  }

  dd {
    margin: 0;
  }

  ul {
    @include list-style;
  }

  .sp-methods {
    @include clearfix;

    dt,
    dd {
      @include clearfix;
      display: block;
    }

    input[type='text'],
    select {
      float: left;
      margin-top: 8px;
      margin-right: 20px;
    }
  }

  .form-section-col {
    width: 100%;
  }

  @media (min-width: $screen-sm-min) {
    .form-section-col {
      width: 50%;
      float: left;
    }
  }
}

.gift-options {
  @include clearfix;
  width: 100%;

  label {
    padding: 0;
    margin: 0 0 0 8px;
    float: left;
    font-size: 12px;
    color: #ff0000;
    font-family: $fontAlternate;
    font-weight: bold;
  }

  input[type='checkbox'],
  input[type='radio'] {
    float: left;
    margin: 0;
    appearance: auto;
  }
}

.gift-message .card_message {
  margin: 5px;
  display: block;
  font-size: 12px;
  width: 100%;
}

.free-gift {
  color: #2dcc70;
  font-weight: bold;
}

.form-section-title {
  h2 {
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 7px;
    border-bottom: 1px solid #ccc;
    color: $bodyTextColor;

    span {
      font-size: 14px;
    }
  }
}

/**** Cross-sell offers in Cart ****/
.disableClick {
  pointer-events: none;
}

/**** Individual Form Styles ****/
/* Billing Form Styles */
#billing-form {
  input[type='text'],
  input[type='email'],
  select {
    min-width: 100%;
    border: 1px solid #ccc;
    float: none;
  }

  select {
    padding: 5px 2px;
  }

  li {
    width: 100%;
  }
}

/* Payment Form Styles */
#multishipping-billing-form {
  .no-display {
    display: none;
  }

  label {
    width: 100%;
  }

  input[type='text'] {
    width: 100%;
    display: block;
  }

  input[type='radio'] {
    float: left;
  }

  #direct_debit_sort_code_1,
  #direct_debit_sort_code_2,
  #direct_debit_sort_code_3 {
    width: 25px;
    float: none;
    display: inline;
    margin-right: 0;
  }

  li {
    width: 100%;
  }

  .buttons-set {
    @include clearfix;

    button {
      @include button-style;
      float: right;
    }

    p {
      float: left;

      a {
        color: $headingColor;
      }
    }
  }
}

#multishipping-payment-form {
  p,
  span,
  label {
    font-family: $fontAlternate;
    font-size: 12px;
  }
}

/* Delivery Form Styles */
#delivery-form {
  li {
    @include clearfix;
    width: 100%;
  }

  input[type='text'] {
    width: 100%;
  }

  .name-firstname {
    margin-bottom: 10px;
  }

  address {
    font-size: 12px;
  }

  .product-name {
    font-family: $fontAlternate;
    font-size: 12px;
    font-weight: bold;
    margin: 10px 0 0;
  }

  p {
    margin: 0;
    font-family: $fontAlternate;
    font-size: 12px;
  }

  .deliver-item-image {
    @include clearfix;
    width: 100%;
    padding-bottom: 25px;
  }

  /* Cards Graphics */
  .img_dd,
  .img_cc {
    margin-top: 10px;
  }

  .img_cc {
    max-width: 228px;
  }

  /* Delivery form box (only shows on direct debit) */
  .delivery-details-item-address {
    @include clearfix;
  }

  /* Forces inputs to be 100% width on mobile */
  .fields {
    width: 100%;

    .input-box {
      //@include clearfix;
    }

    input,
    select {
      width: 100%;
    }
  }

  .address-form {
    label {
      font-size: 12px;
    }
  }

  .delivery-opt-in {
    .field {
      margin-bottom: 10px;
    }

    label {
      font-size: 12px;
      float: none;
    }
  }

  .edit-address,
  .edit-billing-address {
    font-size: 12px;
  }

  .delivery-details-buttons.cart-footer-wrap {
    padding: 0;

    a {
      @include inline-block;
      padding-top: 15px;
    }
  }

  .delivery_country select {
    padding: 5px 2px;
  }

  .publishers-anchor {
    text-decoration: none;
    cursor: pointer;
    font-size: 12px;
  }

  .publishers-list {
    background: #f5f5f5;
    margin: 10px 0px;
    padding: 10px 10px;
    font-size: 12px;

    &.pub-hide {
      display: none;
    }
  }
}

/**** Multishipping Payment Form Styles ****/
.direct-debit-instruction,
.discount {
  p {
    font-family: $fontAlternate;
    font-size: 14px;
  }
}

/**** Checkout Progress Bar Styles ****/
.checkout-progress {
  @include list-style;
  width: 100%;
  border: 1px solid $checkoutBorderColor;
  background: $checkoutBgColor;
  margin: 0 0 20px;
  padding: 10px 5px;
  overflow: hidden;
  text-align: center;

  h2 {
    display: none;
    font-size: 18px;
    font-weight: 600;
    margin: 0 35px 0 0;
    padding: 0;
    float: left;
    text-transform: uppercase;
    color: $checkoutLinkColor;
  }

  a {
    color: $bodyTextColor;

    &:hover {
      color: $checkoutLinkColorActive;
      text-decoration: none;
    }
  }

  li {
    display: inline;
    text-align: center;
    padding-top: 0px;
    margin: 0 10px;
    text-transform: uppercase;
    font-weight: 500;
    color: $checkoutLinkColor;

    a {
      &:hover {
        color: $checkoutLinkColorActive;
      }
    }

    &.active-checkout {
      color: $bodyTextColor;
      font-weight: 700;

      a {
        color: $bodyTextColor;
      }
    }

    &:last-child {
      border-right: none;
    }
  }
}

/**** Minicart Styles ****/
/* Hides red bar when product is added to basket */
.notification {
  display: none !important;
}

.product-cart-info {
  h2 {
    color: $bodyTextColor;
    font-weight: bold;
  }

  p {
    margin: 0;
  }
}

/* Block Cart Styles */
.order-summary,
.order-total {
  display: none;
}

/* Cart Buttons Styles */
.buttons-set {
  @include clearfix;
  width: 100%;

  button {
    @include button-style;
    padding-right: 45px;
    //background:#00933e url("../images/search-sbmt-btn.png") no-repeat scroll 61px 10px !important;
    //@include image-2x("../images/search-sbmt-btn.png", 20px, 20px);
  }
}

/* Cart Totals Styles */
.cart-totals {
  table {
    float: right;

    /* Hides the subotal as this isn't present in old C5 build */
    tbody {
      display: none;
    }

    .price {
      padding-left: 20px;
    }
  }

  /* Hiding Unused Multiple Checkouts Link */
  .checkout-types {
    display: none;
  }
}

/* Clears container class used in some forms */
.input-box {
  //@include clearfix;
}

/* Magento Validation Styles */
.validation-advice {
  font-family: $fontAlternate;
  color: $formErrorColor;
  margin-top: 5px;
  width: 100%;
  float: none;
  text-align: left;
  padding: 0;
}

/* Secure Logos Start */
.secure-logos {
  p {
    @include clearfix;
    font-size: 12px;
    font-family: $fontAlternate;

    span {
      padding: 10px 0 0 10px;
    }
  }
}

/* Payment Methods Start */
/* Importants added to ovveride sagepay styles from seperate css file */
.payment-methods {
  p,
  p strong {
    font-size: 14px;
  }

  .direct-debit & {
    display: none;
  }

  @include clearfix;
  margin-bottom: 20px;

  .payment-label {
    float: left;
    padding-right: 20px;

    input,
    label {
      @include inline-block;
      margin: 0 !important;
      padding-left: 10px;
      cursor: pointer;
    }

    label[for='p_method_paypal_express'] {
      width: 80px;
      height: 40px;
      background: url('https://magazine.imgix.net/payment/payment-paypal-lg.png?fm=png&auto=format&w=180') no-repeat scroll;
      background-size: 100% 100%;
    }

    label[for='p_method_sagepayserver'] {
      width: 150px;
      height: 40px;
      text-indent: -9999px;
      background: url('https://magazine.imgix.net/payment/payment-cards.png?fm=png&auto=format&w=380') no-repeat center center;
      background-size: 152px 80%;
    }

    label[for='p_method_jellyfish_giftcard'] {
      width: 115px;
      height: 35px;
      text-indent: -9999px;
      background: url('https://magazine.imgix.net/payment/payment-giftcard.png?fm=png&auto=format&w=230') no-repeat scroll;
      background-size: 100% 100%;
    }

    label[for='p_method_cryozonic_stripe'] {
      width: 157px;
      height: 40px;
      text-indent: -9999px;
      background: url('https://magazine.imgix.net/payment/stripe.png?fm=png&auto=format&h=120') no-repeat center center;
      background-size: 157px 30px;
    }
  }

  .payment-label.only-stripe {
    label[for='p_method_cryozonic_stripe'] {
      width: 150px;
      height: 40px;
      text-indent: -9999px;
      background: url('https://magazine.imgix.net/payment/payment-cards.png?fm=png&auto=format&w=380') no-repeat center center;
      background-size: 152px 80%;
    }
  }
}

.payment-label.sagepayserver.only-stripe {
  display: none;
}

.payment-label.cryozonic_stripe {
  display: none;
}

.payment-label.cryozonic_stripe.only-stripe {
  display: block;
}

/* iPad Landscape */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .payment-label.cryozonic_stripe {
    display: block;
  }
}

/* iPad Portrait */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .payment-label.cryozonic_stripe {
    display: block;
  }
}

.notice-msg {
  width: 100% !important;
  margin-top: 0 !important;
  margin-bottom: 10px;
  border: 1px solid #d8d8d8;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  color: red;
  background: #fff9f2;

  ul li {
    margin: 0 !important;
  }
}

.payment-methods-content {
  .payment-content {
    width: 100%;

    .secured-by {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;

      &__text {
        flex: 1 1 75%;
        padding: 10px;
      }

      &__img {
        min-width: 130px;
        flex: 0 0 15%;

        img {
          width: 100%;
        }
      }
    }
  }
}

.direct-debit .dd-hide {
  display: none;
}

.direct-debit .direct-debit-title {
  display: block;
}

.direct-debit .credit-card-title {
  display: none;
}

.direct-debit-title {
  display: none;
}

#paypal-continue {
  background: #fff;
  border: none;
}

.discount-form {
  margin-bottom: 20px;

  label {
    font-size: 14px;
  }

  button {
    margin-top: 10px;
  }

  .validation-advice {
    font-size: 14px;
  }
}

#payment_form_jellyfish_giftcard {
  button {
    margin: 10px 0;
  }
}

.validation-failed {
  border: 1px solid $headingColor;
}

/* Styles to ensure only one validation message displays for sortcode */
#sortCodeWrap div {
  display: none;

  &:last-of-type {
    display: block !important;
  }
}

/*Styling for minisites*/
.minisite {
  .cart {
    h1 {
      display: none;
    }

    .back-btn {
      display: none;
    }
  }

  .checkout-progress {
    margin-top: 0;
    margin-bottom: 1px;
  }

  #minisite-header {
    margin-bottom: 10px;
  }

  .promotion-reminder {
    display: none;
  }
}

// Checkout coupon section
.discount-form {
  .field-wrapper {
    margin: 10px;

    input#coupon_code.input-text {
      padding: 5px;
      border: 1px solid $formInputBorder;
    }

    .button {
      -webkit-border-radius: 3px;
      border-radius: 3px;
      padding: 10px;
      text-transform: uppercase;
      -webkit-box-shadow: 0 0;
      box-shadow: 0 0;
      background: #00933e;
      font-weight: 600;
      color: #fff;
      font-size: 12px;
      border: none;
    }

    .button__coupon {
      background: $buttonBgColorAction;

      &--cancel {
        background: $buttonBgColorBack;
      }
    }
  }
}

// Giftcard Form on Checkout
.giftcard-form-checkout {
  width: 100%;
  padding: 10px;

  input {
    padding: 5px;
    border: 1px solid $formInputBorder;
  }

  .button {
    -webkit-border-radius: 3px;
    border-radius: 3px;
    padding: 10px;
    text-transform: uppercase;
    -webkit-box-shadow: 0 0;
    box-shadow: 0 0;
    background: #00933e;
    font-weight: 600;
    color: #fff;
    font-size: 12px;
    border: none;
  }

  .button__coupon {
    background: $buttonBgColorAction;

    &--cancel {
      background: $buttonBgColorBack;
    }
  }
}

.success-msg {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;

  li {
    text-align: center;
    background: $successNotificationBgColor;
    padding: 10px;
    color: $successNotificationTextColor;

    h1 {
      margin: 0 0 15px;
      font-weight: 600;
      font-size: 13px;
      color: $successNotificationTextColor;

      p {
        font-size: 13px;
        color: $successNotificationTextColor;
      }
    }
  }
}

.error-msg {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;

  li {
    text-align: center;
    background: $errorNotificationBgColor;
    padding: 10px;
    color: $errorNotificationTextColor;
  }
}

/* ==========================================================================
        MAGAZINE CART RESPONSIVE STYLES
       ========================================================================== */
/* Max width media query used only here as mobile styles are so different to tablet.
       Avoids having to ovveride many styles */
@media (max-width: $screen-xs-max) {
  /**** General Cart Styles ****/
  /**** Generic Form Styles - Used across all steps of billing ****/
  #billing-form,
  #multishipping-billing-form,
  #delivery-form,
  .cart {
    /* CSS change to prevent zoom of select box when focused on IOS */
    select {
      font-size: 16px;
    }
  }

  .product-cell-inner-wrap {
    .gf-info {
      font-size: 14px;
      margin: 0;
      font-family: 'Open Sans', sans-serif;
      color: #666;

      &--nooverflow {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .cart {
    @include clearfix;
    padding: 20px 15px;

    h1 {
      display: none;
    }

    p {
      margin: 0;
    }
  }

  .multiple-checkout {
    padding: 0 10px;
  }

  /**** Cart Table Styles ****/
  /* Note - table styles need breaking to divs for mobile layout */
  .cart-table {
    @include clearfix;
    display: block;

    tbody,
    tfoot,
    tr,
    td {
      display: block;
    }

    tr {
      //padding-bottom:30px;
      &.even {
        border-bottom: 2px solid #000;
        padding: 5px;
        margin: 20px 0;
        height: 40px;
      }
    }
  }

  .product-cart-remove {
    float: left;
    padding: 0 10px 10px !important;

    .btn-remove,
    .btn-remove2 {
      color: $bodyTextColor;
    }
  }

  .product-cart-add {
    float: right;
    padding: 0 10px 10px !important;
  }

  .cart-price {
    font-weight: bold;
    color: $headingColor;
    margin-right: 15px;
  }

  .dd_small {
    padding: 10px 0;
  }

  .product-cell-inner-wrap {
    @include clearfix;

    .product-image {
      margin-bottom: 10px;
      display: block;
    }
  }

  /* Cart Table Heading Styles */
  /* Hiding thead as it doesn't fit with mobile design */
  thead {
    display: none;
  }

  /* Cart Table Product Image Styles */
  .product-cart-image {
    width: 130px;
    float: left;

    img {
      max-width: 113px !important;
      height: auto !important;
      margin: 10px 0;
    }
  }

  .form-section-container {
    margin: 0;
  }

  /* Cart Table Product Info Styles */
  .product-cart-info {
    width: 100%;
    padding-bottom: 20px;

    /* Taking out button for removing product as there should only be one in the table */
    .btn-remove {
      display: none;
    }

    /* Removing as this doesn't feature in the design */
    .product-cart-sku {
      display: none;
    }

    .product-name {
      font-size: 16px;
      font-family: $fontAlternate;
      color: #333;
    }

    .product-sub-name,
    .product-delivery {
      font-size: 14px;
      margin: 0;
      font-family: $fontAlternate;
      color: #666;
    }

    .product-issues {
      font-size: 16px;
      margin: 0;
      font-family: $fontAlternate;
      color: #666;
      font-weight: bold;
    }
  }

  /* Cart Table Product Action Styles */
  .product-cart-actions {
    input {
      width: 30px;
      text-align: center;
    }

    /* Reset button style to be a link */
    button {
      color: $headingColor;
      background: none;
      border: none;
      padding: 0;
      margin-left: 10px;
    }
  }

  /* Cart Table Payment Styles */
  .product-cart-payment {
    .cards {
      float: right;
    }
  }

  /* Forces Checkboxes below image */
  .product-cart-info {
    position: static;
    padding-bottom: 10px;
  }

  .gift-checkboxes {
    text-align: left;

    .gift-message-input {
      resize: none;
      margin-top: 5px;
      padding: 5px;
      border: 1px solid #dcdcdc;
      width: 100%;
    }
  }

  .gift-options {
    text-align: left;
    margin-left: 10px;
    display: inline-block;
    height: 35px;
    line-height: 35px;

    input,
    label {
      float: none !important;
    }
  }

  .giftcard-options-msg {
    margin-top: 0;
    text-align: center;
  }

  /* Cart Labels Used as table cells are displayed as rows */
  .cart-mobile-label {
    float: left;
    font-weight: bold;

    .product-cart-payment & {
      padding-top: 12px;
    }
  }

  /**** Cart Footer Styles ****/
  .cart-totals-wrapper {
    @include clearfix;

    .cart-totals {
      @include clearfix;
      margin-bottom: 20px;
    }
  }

  .cart-footer-wrap {
    @include clearfix;

    button {
      @include button-style;
      float: right;
      font-size: 12px;
      margin-left: 0;

      &.btn-continue {
        float: left;
        background: #ff0d00;
      }
    }
  }

  /**** Cross-sell Styles ****/
  #crosssell-products-list {
    padding: 0;
    margin: 0;
  }

  .crosssell .item {
    float: none;
    width: 100%;
    list-style: none;
    border-bottom: 1px dotted #ccc;
  }

  /**** Delivery Form Styles ****/
  .payment-footer-btns {
    button {
      background: #2dcc70 !important;
      background-image: none;
      text-align: center;
      width: 50%;
      padding: 10px;
    }

    margin-top: 20px;
    text-align: center;
  }

  .delivery-details-item {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 2px solid #000;

    img {
      width: 130px;
      height: auto;
      //margin:0 10px 10px 0;
      float: left;
    }

    .form-section-col {
      @include clearfix;
    }
  }

  .deliver-item-image {
    width: 45% !important;
    float: left;
  }

  .delivery-details-item-address {
    background: #ededed;
    padding: 10px;
  }

  .delivery-details-buttons {
    @include clearfix;

    .back-link {
      float: left;
    }

    button {
      @include button-style;
    }
  }

  /**** Direct Debit Form Styles ****/
  .direct-debit-form {
    margin: 20px 0;

    li {
      @include clearfix;
      margin: 5px 0;

      label {
        display: block;
      }
    }

    input {
      margin: 0;
      width: 100%;
    }

    .sortcode {
      width: 36px;
      text-align: center;
    }
  }

  /**** Order Confirmation Styles ****/

  .success--bottom {
    float: none;
    width: 100%;

    img {
      display: block;
      width: 100%;
    }
  }

  .success--sidebar {
    display: none;
  }

  .order-confirmation {
    padding: 0 0;

    h2,
    h3,
    p {
      font-size: 14px;
    }

    h3,
    p {
      font-family: $fontAlternate;
    }

    .sub-title {
      text-transform: none;
      font-weight: normal;
    }

    .order-confirmation-address {
      padding: 20px 0 0;
    }

    .order-confirmation-items {
      li {
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
      }

      .magazine-title {
        font-family: $fontRegular;
      }

      img {
        margin-bottom: 10px;
      }

      .order-summary-price {
        color: $headingColor;
      }
    }

    .order-confirmation-totals {
      padding: 10px 0 0 0;

      p {
        font-weight: bold;
        font-size: 16px;
      }
    }

    .order-confirmation-btns {
      button {
        width: 200px;
        float: right;
      }

      .fa-chevron-right {
        line-height: 17px;
        float: right;
      }
    }

    .order-confirmation-cms {
      margin-bottom: 20px;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  /**** Billing Form Styles ****/
  .billing-details {
    margin-bottom: 20px;
  }

  /**** Payment Step Styles ****/
  .back-link {
    display: none;
  }

  .direct-debit-title,
  credit-card-title {
    span {
      float: right;
    }
  }

  .mcheckout-payment-index .sidebar {
    display: none;
  }

  /* Secure Logos Start */
  .secure-logos {
    padding: 0 15px;
    margin-top: 20px;

    p {
      @include clearfix;
      font-size: 12px;
      font-family: $fontAlternate;

      span {
        float: right;
        width: 90%;
        padding: 0;
      }
    }
  }

  /* Payment Methods Start */
  /* Importants added to ovveride sagepay styles from seperate css file */
  .payment-methods {
    margin-top: 20px;

    .direct-debit & {
      display: none;
    }

    @include clearfix;
    margin-bottom: 20px;

    .payment-label {
      float: left;
      padding-right: 20px;
      display: block;
      width: 100%;
      margin-bottom: 10px;

      label {
        margin-left: 10px !important;
      }
    }

    .payment-label.sagepayserver {
      .only-stripe {
        display: none;
      }
    }
  }

  .payment-methods-content {
    .payment-content {
      width: 100%;

      .secured-by {
        &__text {
          font-size: 12px;
        }

        &__img {
          flex: 1 1 15%;
        }
      }
    }

    iframe#sagepaysuite-server-incheckout-iframe {
      overflow: hidden;

      html {
        overflow: hidden;
      }
    }
  }

  .direct-debit .dd-hide {
    display: none;
  }

  .direct-debit .direct-debit-title {
    display: block;
  }

  .direct-debit .credit-card-title {
    display: none;
  }

  .direct-debit-title {
    display: none;
  }

  /* Empty Cart Page */
  .cart-empty-wrap {
    padding: 0 15px;
  }

  /**** Subscription Offers Styles ****/
  .subscriptn_offers {
    margin: 20px auto;
    padding: 10px;
    padding-right: 0;
    height: 100%;
    min-height: 230px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background-color: #ccc;
    max-width: 700px;
    text-align: center;

    h3 {
      color: #000;
    }

    ul {
      display: block;
      min-height: 4.5em;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      float: left;
      margin: 0;
      width: 33%;
    }

    img {
      max-width: 80%;
      width: 100%;
      height: auto;
      margin-bottom: 10px;
    }
  }

  .product-cart-add a {
    color: #333;
  }

  // Checkout coupon section
  .discount-form {
    .field-wrapper {
      .button__coupon {
        background: $mobileButtonBgColorAction;

        &--cancel {
          background: $mobileButtonBgColorBack;
        }
      }
    }
  }

  .product-cart-payment {
    display: none !important;
  }

  .product-cart-price {
    display: inline-block;
    text-align: right;

    .cart-mobile-label {
      float: none;
      margin-right: 7px;
    }

    .cart-price {
      float: none;
    }
  }

  .product-cart-payment {
    .product-cart-mobile-row {
      display: none !important;
    }
  }

  .product-cell-payment-mobile.sub-options-content {
    display: inline-block;
    padding: 5px;

    .dd_small {
      .img_dd {
        display: inline-block;
        max-width: 58px;
      }

      .img_cc {
        display: none;
      }

      .img_cc_checkout {
        display: inline-block;
        display: none;
      }
    }

    .cc_small {
      .img_dd {
        display: none;
      }

      .img_cc {
        display: inline-block;
        max-width: 58px;
        max-width: 170px;
      }

      .img_cc_checkout {
        display: inline-block;
        max-width: 200px;
      }
    }
  }
}

@media (min-width: $screen-sm-min) {
  /**** Generic Form Styles - Used across all steps of billing ****/
  #billing-form,
  #multishipping-billing-form,
  #delivery-form,
  .cart {
    label {
      float: left;
      margin-right: 10px;
    }

    .input-box {
      float: right;
      min-width: 333px;
    }

    .checkbox-field {
      float: right;
      width: 333px;
    }

    .checkbox-label {
      float: none;
    }

    select {
      background-color: white;
    }
  }

  .address-form {
    select {
      border-color: $formInputBorder;
    }

    .save-address {
      -webkit-border-radius: 3px;
      border-radius: 3px;
      padding: 10px;
      text-transform: uppercase;
      float: right;
      margin: 0;
      -webkit-box-shadow: 0 0;
      box-shadow: 0 0;
      background: #00933e;
      font-weight: 600;
      color: #fff;
      font-size: 12px;
      border: none;
    }

    .delivery_country,
    input[type='text'] {
      border: 1px $formInputBorder solid;
      background-color: white;
      border-width: 1px;
    }
  }

  /**** General Cart Styles ****/
  .cart {
    .cart-header {
      @include clearfix;
      border-bottom: 1px dotted #ccc;

      h1 {
        float: left;
      }

      ul {
        padding-top: 5px;
        float: right;
      }

      button {
        @include button-style;
      }
    }

    input {
      float: left;
      margin-top: 8px;
      margin-right: 10px;
    }

    h2 {
      margin: 0 0 8px;
      padding: 0 0 8px;
      border-bottom: 1px solid #333;
    }

    p {
      margin-bottom: 5px;
    }

    ul {
      @include list-style;
    }

    .cart-mobile-label {
      display: none;
    }

    form {
      table {
        thead tr th {
          text-align: center;
        }

        width: 100%;

        tr {
          &.first {
            border-top: none;
          }

          &.odd {
            border-top: 1px solid #a5a5a5;
          }

          th {
            padding: 10px;
            background: #d8d8d8;
            color: #666;
            border-right: 1px solid #fff;
            font-size: 10px;

            &:last-child {
              border-right: none;
            }
          }

          td {
            display: table-cell;
            padding: 20px 0;
            vertical-align: top;

            &:last-child {
              .product-cell-inner-wrap {
                border-right: none;
              }
            }
          }
        }

        .product-cart-image {
          padding: 20px 0;
          width: 200px;

          a {
            display: block;
            padding: 0px;
          }

          img {
            width: 100%;
            height: auto;
            max-width: 150px;
          }
        }

        .product-cart-info {
          padding: 20px 0;

          .btn-remove2 {
            display: none;
          }

          .product-name {
            font-size: 16px;
          }
        }

        .product-cart-price,
        .product-cart-total {
          width: auto;
          float: none;
        }

        .product-cart-price {
          font-weight: bold;
          color: $headingColor;
        }

        .product-cart-actions {
          width: auto;
          float: none;
        }

        .product-cart-remove {
          width: 112px;
          padding: 0 30px 10px;
        }

        .cart-footer-actions {
          text-align: right;
        }

        .btn-remove {
          color: $bodyTextColor;
        }
      }
    }

    .free-gift {
      color: #00933e;
    }

    .cart-totals-wrapper {
      @include clearfix;

      table {
        width: 100%;

        td {
          vertical-align: middle;
        }

        .a-right {
          text-align: right;
        }
      }

      .cart-totals {
        td {
          font-family: $fontRegular;
          padding: 10px 15px;
          text-transform: uppercase;

          /* Targets last col of this section specifically */
          &:last-child {
            color: $totalsCurrencyColor;
          }
        }
      }

      .method-checkout-cart-methods-multishipping {
        text-align: right;
      }
    }
  }

  /* Empty Cart Page */
  .cart-empty-wrap {
    a {
      color: $headingColor;
    }
  }

  /* Adds grey background to billing details box */
  .billing-details {
    background: #f5f5f5;
  }

  .form-section-container {
    //@include border-radius(5px);
    //border:1px solid #a5a5a5;
    padding: 20px;
  }

  .cart-totals {
    @include clearfix;
    border: 1px solid #a5a5a5;
    margin-bottom: 20px;
  }

  .grand-total-price {
    border-left: 2px solid #fff;
  }

  .cart .form-section-container {
    padding: 0;
  }

  /**** Product Styles ****/
  .product-cell-inner-wrap {
    padding: 0 10px;
    min-height: 180px;

    .product-image {
      display: block;
    }

    .qty {
      width: 40px;
      text-align: center;
    }

    .btn-update {
      background: none;
      border: none;
      text-decoration: underline;
      float: right;
      padding: 0;
      color: $formLinkColor;

      &:hover {
        text-decoration: none;
      }
    }

    .cart-links {
      li {
        text-align: right;
      }
    }
  }

  .cart-item {
    padding-bottom: 20px;
  }

  .cart-product {
    .product-image {
      @include inline-block;
    }
  }

  /**** Checkout Progress Bar Styles ****/
  .checkout-progress {
    padding: 15px;
    line-height: 16px;

    h2 {
      display: block;
    }

    li {
      @include inline-block;
      padding-left: 30px;
    }
  }

  /**** Delivery Form Styles ****/
  .delivery-details-item {
    @include clearfix;
    width: 100%;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;

    img {
      float: left;
      margin-right: 20px;
    }
  }

  .delivery-details-buttons {
    @include clearfix;

    .back-link {
      float: left;
    }

    button {
      @include button-style;
    }
  }

  /**** Billing Form Styles ****/
  #billing-form {
    li {
      width: 60%;
    }

    .buttons-set {
      @include clearfix;
      width: 100%;

      button {
        font-size: 14px;
      }
    }
  }

  /**** Direct Debit Form Styles ****/
  .direct-debit-form {
    margin: 20px 0;

    li {
      @include clearfix;
      margin: 5px 0;

      label {
        display: block;

        em {
          color: $headingColor;
        }
      }
    }

    input {
      margin: 0;
      width: 30%;
    }

    .sortcode {
      width: 36px;
      text-align: center;
    }
  }

  .back-link {
    a {
      color: $headingColor;
    }
  }

  /**** Cart Footer Styles ****/
  .cart-footer-wrap {
    @include clearfix;
    padding: 0 0 20px 0;
  }

  .cart-footer-wrap,
  .payment-footer-btns {
    @include clearfix;
    width: 100%;

    button {
      @include button-style;
      float: right;
      margin: 20px 10px 0 0px;
      font-weight: bold;
      font-size: 12px;
    }

    button.btn-continue,
    button.button-payment {
      @include button-style;
      float: left;
      margin: 20px 0 0 10px;
      font-weight: bold;
      font-size: 12px;
    }
  }

  .payment-footer-btns {
    button {
      //background:#00933e url("../images/search-sbmt-btn.png") no-repeat scroll 110px 10px !important;
      //@include image-2x("../images/search-sbmt-btn.png", 20px, 20px);
      //&:hover{
      //	background:#00b54c url("../images/search-sbmt-btn.png") no-repeat scroll 112px 10px !important;
      //	@include image-2x("../images/search-sbmt-btn.png", 20px, 20px);
      //}
    }
  }

  .cart-footer-wrap {
    button {
      //background:#00933e url("../images/search-sbmt-btn.png") no-repeat scroll 90% 10px !important;
      //@include image-2x("../images/search-sbmt-btn.png", 20px, 20px);
      //&:hover{
      //	background:#00b54c url("../images/search-sbmt-btn.png") no-repeat scroll 92% 10px !important;
      //	@include image-2x("../images/search-sbmt-btn.png", 20px, 20px);
      //}
      &.back-btn {
        background: $mobileButtonBgColorBack;
        padding-right: 10px;
        float: left;
      }
    }
  }

  /**** Order Confirmation Styles ****/
  .success--bottom {
    float: none;
    width: 100%;

    img {
      display: block;
      margin: 0 auto;
    }
  }

  .success--sidebar {
    float: none;

    img {
      display: block;
      margin: 0 auto;
    }
  }

  .order-confirmation {
    .sub-title {
      text-transform: none;
      font-size: 14px;
    }
  }

  .order-confirmation-text {
    @include clearfix;

    p {
      font-family: $fontAlternate;
    }

    .order-confirmation-message {
      width: 100%;
    }

    .order-confirmation-address {
      float: left;
      width: 30%;
    }
  }

  .order-confirmation-items {
    .items {
      border-bottom: 1px solid #ccc;
      display: flex;
      flex-wrap: wrap;
    }

    li {
      padding: 10px 10px 10px 0;
      width: 50%;
    }

    .magazine-title {
      text-transform: uppercase;
      font-family: $fontRegular;
    }

    p {
      font-family: $fontAlternate;
    }

    .price {
      color: $headingColor;
    }
  }

  .order-confirmation-totals {
    padding: 20px 0;

    p {
      font-family: $fontRegular;
      font-weight: bold;
      font-size: 16px;
    }

    .price {
      font-family: $fontAlternate;
    }
  }

  /* Payment Step Styles */
  .direct-debit-title {
    span {
      float: right;
      padding-top: 20px;
    }

    .price {
      color: $headingColor;
      font-weight: bold;
    }
  }

  .credit-card-title {
    .price {
      color: $headingColor;
      font-weight: bold;
    }
  }

  .payment-label {
    /*display:none;*/
  }

  .sage-message {
    border: 1px dotted #a5a5a5;
    padding: 5px;
  }

  /**** Subscription Offers Styles ****/
  .subscriptn_offers {
    margin: 20px auto;
    padding: 10px;
    padding-right: 0;
    height: 100%;
    min-height: 230px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background-color: #ccc;
    max-width: 700px;
    text-align: center;
  }

  .subscriptn_offers {
    h3 {
      color: #000;
    }

    ul {
      display: block;
      min-height: 4.5em;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      float: left;
      margin: 0;
      width: 33%;
    }

    img {
      max-width: 80%;
      width: 100%;
      height: auto;
      margin-bottom: 10px;
    }
  }
}

@media (min-width: $screen-md-min) {
  /**** Order Summary Styles ****/
  .order-summary {
    @include clearfix;
    display: block;
    margin: 0px;

    //padding:10px;
    .block-title {
      border: 1px solid $checkoutBorderColor;
      border-bottom: none;
      text-align: center;
      color: $checkoutLinkColor;
      padding: 15px;
      margin: 0px;
      font-weight: 700;
      text-transform: uppercase;
      background: $checkoutBgColor;
    }

    .block-content {
      padding: 0px;
      border: 1px solid $checkoutBorderColor;
      background: $checkoutBgColor;
    }

    .product-details {
      .price {
        float: left;
        font-weight: 600;
        color: $headingColor;
      }
    }

    p {
      margin: 0;
      font-size: 12px;
    }

    address {
      font-style: normal;
      font-size: 12px;
    }

    ul {
      @include list-style;
      background: #fff;
      padding: 0 10px;

      li {
        @include clearfix;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;

        &:last-child {
          border-bottom: none;
        }

        p:first-child {
          font-size: 14px;
          font-weight: 700;
        }
      }
    }

    a {
      float: right;
      margin-left: 10px;
      color: $bodyTextColor;
      width: auto;
      text-align: right;
      display: block;
      padding: 10px;
      font-weight: 600;

      &:hover {
        text-decoration: underline;
      }
    }

    .summary {
      @include clearfix;
      padding: 15px 10px;
      border-top: 1px solid $checkoutBorderColor;

      .label {
        color: $totalsLabelColor;
        font-weight: 600;
        font-size: 14px;
      }

      .price {
        float: right;
        color: $totalsCurrencyColor;
        font-weight: 600;
        font-size: 14px;
      }
    }

    .subtotal {
      float: left;
      padding: 10px 0 0;
      margin: 0;

      .label {
        color: #fff;
      }
    }

    .order-summary-btn {
      @include inline-block;
      margin-left: 10px;
      width: 20px;
      height: 20px;
    }

    .product-cards {
      margin: 10px 0;
      max-width: 200px;
    }
  }

  /* Styles For Blue promo box below Order Summary */
  .security-info {
    background: #e5f0ff;
    padding: 10px;
    margin: 20px 0;

    h3 {
      font-weight: bold;
      color: #3a66a4;
      font-size: 13px;
      line-height: 15px;
    }

    ul {
      padding: 0;
      margin: 0;

      li {
        list-style: none;
        color: #3a66a4;
        font-size: 12px;
        margin-bottom: 5px;

        span {
          @include inline-block;

          width: 30px;
        }
      }
    }
  }

  /**** Subscription Offers Styles ****/
  .subscriptn_offers {
    margin: 20px auto;
    padding: 10px;
    height: 100%;
    min-height: 100%;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background-color: #ccc;
    max-width: 90%;
  }

  .subscriptn_offers {
    h3 {
      color: #000;
    }

    ul {
      display: block;
      min-height: 4.5em;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      float: left;
      margin-right: 0;
      width: 16%;
    }

    img {
      max-width: 134px;
      width: 100%;
      height: auto;
    }
  }

  .gift-checkboxes {
    text-align: center;

    .gift-message-input {
      margin-top: 5px;
    }
  }
}

@media (min-width: $screen-lg-min) {
  /**** Subscription Offers Styles ****/
  .subscriptn_offers {
    margin: 20px auto;
    padding: 10px;
    height: 100%;
    min-height: 100%;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background-color: #ccc;
    max-width: 100%;
    text-align: left;
  }

  .subscriptn_offers {
    h3 {
      color: #000;
    }

    ul {
      display: block;
      min-height: 4.5em;
      list-style: none;
      margin: 0;
      padding: 0 0 0 120px;
    }

    li {
      float: left;
      margin-right: 0;
      width: 15%;
    }

    img {
      max-width: 134px;
      width: 100%;
      height: auto;
    }
  }

  /**** Direct Debit Styles ****/
  .direct-debit-form {
    max-width: 450px;

    li {
      label {
        display: inline;
      }

      span {
        width: 70%;
        float: right;

        input {
          width: 100%;
        }
      }
    }
  }
}

#shopping-cart-table {
  th {
    background: $sectionBackground;
    color: #333;
    border-right: none;
    font-size: 12px;
  }
}

@media (max-width: 414px) {
  #billing-form,
  #multishipping-billing-form,
  #delivery-form,
  #multishipping-payment-form {
    input[type='text'],
    input[type='email'],
    .input-text {
      font-size: 16px !important;
    }
  }
}

.cssoverlay {
  position: fixed;
  top: 2000px;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  transition: opacity 500ms;
  display: none;
  opacity: 0;
  z-index: 10000;
}

.cssoverlayactive {
  display: block;
  opacity: 1;
  top: 0;
}

.contryid--center {
  margin-top: 35px;
}

.deliverybtnholder {
  float: right;
  font-size: 12px;
  padding: 6px 0;
  margin-left: 50px;

  .deliverybtn {
    color: red;
    font-size: 12px;
    border-bottom: 1px red dotted;
    cursor: pointer;
    line-height: 17.1428px;
    text-decoration: none;
  }
}

.popup {
  width: 400px;

  h3 {
    color: #212529;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    margin: 0;
  }
}

.popup {
  margin: 25% auto;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  width: 35%;
  position: relative;
  transition: all 5s ease-in-out;
  color: #212529;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    transition: all 200ms;
    font-size: 30px;
    font-weight: bold;
    text-decoration: none;
    color: #333;
    float: right;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;
    opacity: 0.5;
  }
}

@media screen and (max-width: 749px) {
  .contryid--center {
    margin-top: unset;
  }

  .deliverybtnholder {
    float: right;
    font-size: 12px;
    padding: 3px 0;
    margin-left: unset;

    .deliverybtn {
      color: red;
      font-size: 12px;
      border-bottom: 1px red dotted;
      cursor: pointer;
      line-height: 17.1428px;
      text-decoration: none;
    }
  }

  .popup {
    width: 90%;
    margin-left: 5%;
    box-sizing: border-box;
  }

  .order-ids {
    float: right;
  }
}

.order-confirmation-items.form-section-container {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
}

.order-confirmation-cms {
  .order-confirmation-message {
    //width: 100%;

    a {
      text-decoration: underline;
      color: #ff0d00;
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
    }
  }
}

.order-confirmation-message {
  margin: 10px;

  .thankyou-order {
    font-weight: 600;
    border-bottom: 0;
    font-size: 18px;
    color: red;
    margin-bottom: 0;
  }
}

.center {
  text-align: center;
}

.red {
  color: red;
}

li.getAddress_autocomplete_suggestion {
  margin: 5px;
  width: auto !important;
}

.delivery-details-item-address .getAddress_autocomplete_list {
  margin-top: 30px;
  padding: 5px;
}

ul#getAddress-autocomplete-list {
  max-height: 300px;
  scroll-behavior: auto;
}

#cart-form {
  display: inline-block;
}

@media (max-width: $screen-md-min) {
  .content__right,
  .content__left {
    display: none !important;
  }
}

.debug {
  &__header {
    display: flex;
    min-height: 40px;
    color: red;
    justify-content: center;
    align-items: center;
  }
}

.header--cart {
  visibility: hidden !important;
  height: 0px;
}
</style>
